import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) => {
  return createStyles({
    label: {
      width: '100px',
      textAlign: 'left',
      fontSize: 14
    },
    leftAlignContainer: {
      //左寄せ
      display: 'flex',
      alignItems: 'left',
      justifyContent: 'left',
      marginLeft: -3
    },
    itemMargin: {
      margin: '0px 3px'
    },
    textStyle: {
      fontSize: 18
    },
    radioLabel: {
      textAlign: 'left',
      marginRight: 20
    },
    input: {
      width: '100%'
    },
    gridItem: {
      paddingBottom: 10
    },
    flexWrap: {
      display: 'flex',
      flexWrap: 'wrap'
    },
    helperText: {
      color: '#F44336',
      fontSize: '0.75rem',
      position: 'relative',
      top: '-6px',
      marginLeft: '16px',
      marginRight: '16px',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif;'
    },
    dropAreaWrap: {
      border: '1px solid silver',
      padding: 10,
      borderRadius: 5,
      marginBottom: 15
    },
    dropArea: {
      border: '1px dashed silver',
      borderRadius: 10,
      paddingTop: 5,
      paddingBottom: 5
    },
    costSubContainer: {
      '@media screen and (min-width:600px)': {
        paddingLeft: 5
      }
    },
    imageListContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      marginTop: 10
    },
    referFileButtonWrapper: {
      textAlign: 'center',
      marginTop: 10,
      marginBottom: 10
    },
    referFileButtonWrapperRwd: {
      textAlign: 'center',
      fontSize: 12
    },
    referFileButtonRwd: {
      backgroundColor: '#007dff',
      color: '#fff',
      width: 200,
      display: 'table-cell',
      verticalAlign: 'middle',
      borderRadius: 5,
      height: 34,
      '&:hover': {
        backgroundColor: '#2691ff',
        boxShadow: 3
      }
    },
    loadingIconClearWrapper: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      marginTop: '-12px',
      marginLeft: '-100px',
      zIndex: 1
    }
  });
});
